import moment from 'moment'
import Vue from 'vue'
import numeroEnLetras from './numeroEnLetras'

const filters = {
  numeroEnLetras,
  myDate: Vue.filter('formatDate', function (value) {
    if (value) {
      return moment(String(value), 'YYYY-MM-DD').format('DD-MM-YYYY')
    }
  }),

  myDate2: Vue.filter('formatDate', function (value) {
    if (value) {
      return moment(String(value), 'DD-MM-YYYY').format('DD-MM-YYYY')
    }
  }),

  formatDateArg: Vue.filter('formatDate', function (value) {
    if (value) {
      return moment(String(value), 'DD/MM/YYYY').format('DD-MM-YYYY')
    }
  }),

  formatDateTime: Vue.filter('formatDateTime', function (value) {
    if (value) {
      return moment(value).format('DD/MM/YYYY HH:mm')
    }
  }),

  myMoney: Vue.filter('formatMoney', function (value) {
    if (value || value === 0 || value === '0') {
      let val = (Number(value) / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }),
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    if (Object.keys(filters).length === 0) return

    Object.keys(filters).forEach(filter => {
      /* eslint-disable no-console */
      if (process.env.NODE_ENV === 'development') {
        console.log(`installed ${filter} filter globally`)
      }
      /* eslint-enable no-console */

      Vue.filter(filter, filters[filter])
    })

    Vue.prototype.$filters = Vue.options.filters
  },
}
